import { getRegional } from "library/getRegional";
import { SvgInline } from "../../SvgInline/SvgInline";
import styles from "./promotion.module.scss";

export function Promotion() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div
          className={`${styles.image} ${
            getRegional("code") === "AU" ? styles.auImg : styles.nzImg
          }`}
        />
        <div className={styles.text}>
          <h2 className="h3">
            It's now even easier to view your loans online.
          </h2>
          <div>
            The new Latitude Service Centre will allow you to track your
            personal loan account online.
          </div>
          <ul className={styles.list}>
            <li>
              <SvgInline name="icon-tick-small" />
              Link your personal loan account to your Latitude ID
            </li>
            <li>
              <SvgInline name="icon-tick-small" />
              Keep on top of repayments easily
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
